<template>
    <div>
        <template v-if="retailer_dashboard == true && data !== null">
            <!-- <div class="row mb-3">
                <div class="col-md-12">
                    <p v-html="balance"></p>
                </div>
            </div> -->
            <div v-if="vendors_proccessed_count == 0" class="welcome-screen-main">
                <div class="head align-center mb-5">
                    <h1> Welcome {{user_name}}! </h1>
                    <p> Getting Started with Finja Business is easy, Begin with few steps below and experience a hassle free and fully organized payroll management system. </p>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <div class="welcome-content align-center">
                            <div class="icon-holder">
                                <img src="/images/welcome-icon1.png" alt="" />
                            </div>
                            <div class="text mt-4 mb-3">
                                <p> Finja Business allows manual on-boarding of employees. Create your employee list </p>
                            </div>
                            <router-link to="/employees" class="btn btn-primary"> Add Employee</router-link>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="welcome-content align-center">
                            <div class="icon-holder">
                                <img src="/images/welcome-icon2.png" alt="" />
                            </div>
                            <div class="text mt-4 mb-3">
                                <p> Finja Business allows manual on-boarding of vendors. Create your vendors list </p>
                            </div>
                            <router-link to="/vendors" class="btn btn-primary"> Add Vendor</router-link>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="welcome-content align-center">
                            <div class="icon-holder">
                                <img src="/images/welcome-icon3.png" alt="" />
                            </div>
                            <div class="text mt-4 mb-3">
                                <p> Add Valuable information to set up your company profile </p>
                            </div>
                            <router-link to="/companyProfile" class="btn btn-primary"> Edit Company</router-link>
                        </div>
                    </div>
                </div>
                <div class="partner-list-main align-center mt-5 mb-1" v-if="$global.user_vr_corp == 'NO'">
                    <ul class="partner-list">
                        <li class="d-inline-block partner-list-item"> <img v-bind:src="'/banks/'+$global.user_company_payment_engine+'.png'" alt="" /> </li>
                    </ul>
                </div>
            </div>
            <div v-else class="row">
                <div class="col-md-9 dashboard-left">
                    <div class="row top-widgets-row">
                        <div class="col-md-4 widgets-col">
                            <div class="payroll-counter-box active-employee">
                                <div class="top-box">
                                    <span class="title" :title="active_vendors_count"> <em class="rollover"> {{active_vendors_count}} </em> </span>
                                    <p> Retailer Count </p>
                                </div>
                                <div class="foot-box"></div>
                            </div>
                        </div>
                        <div class="col-md-4 widgets-col">
                            <div class="payroll-counter-box payroll-processed">
                                <div class="top-box">
                                    <span class="title" :title="vendors_proccessed_count"> <em class="rollover"> {{vendors_proccessed_count}} </em> </span>
                                    <p> Retailer Payments </p>
                                </div>
                                <div class="foot-box"></div>
                            </div>
                        </div>
                        <div class="col-md-4 widgets-col">
                            <div class="payroll-counter-box last-payroll">
                                <div class="top-box">
                                    <span class="title" :title="last_vendor_proccessed_amount"> <em class="rollover"> {{formatAmount(last_vendor_proccessed_amount)}} </em>  </span>
                                    <p> Last Payment Volume </p>
                                </div>
                                <div class="foot-box"></div>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col charts">

                            <div class="charts-holder">
                                <div class="chart-head">
                                    <h2> Retailer Payments </h2>

                                </div>
                                <div class="chart-inner payrol-chart">
                                    <div id="vendor_payment" class="chart"></div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 dashboard-right">
                    <div class="dashboard-right-main">
                        <div class="d-right-box recent-added">
                            <h2> Recently Added Retailer(s) </h2>
                            <div class="recent-added-inner">
                                <div class="recent-added-emp-box" v-for="vendor in recently_added_vendors" v-bind:key="vendor.id">
                                    <div class="emp-title">
                                        {{vendor.name.charAt(0).toUpperCase()}}
                                    </div>
                                    <p class="emp-detail">
                                        {{vendor.name}}
                                        <span class="added-date">
                                            <i class="far fa-clock"></i> {{vendor.created_at}}
                                        </span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else-if="retailer_dashboard === null && data === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="retailer_dashboard == false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    var payroll_chart;
    var bill_chart;
    var colors=['#FF6A33','#FFA533','#33FFAA','#FFA833','#00FF00','#FF0000','#0000FF','#FF5233','#FF3355','#FF3336','#94FF33','#FF3333','#FA8072','#E9967A','#C0C0C0'];
    export default {
        data() {
            return {
                retailer_dashboard : null,
                user_name : null,
                data : null,
                active_vendors_count: '',
                vendors_proccessed_count: 0,
                last_vendor_proccessed_amount: '',
                recently_added_vendors: [],
                monthly_vendor_data: [],
                monthly_bill_data: [],
                // balance: 'Getting Master Account Balance...',
            };
        },
        mounted() {
            this.can('retailer_dashboard').then(result => {
                this.retailer_dashboard = result.retailer_dashboard;
                this.user_name = result.user_name;
            }).then(result => {
                if(this.retailer_dashboard == true){
                    this.getCompanyVendorDashboardData();
                    // this.getCurrentBalanceData();
                }
            });
        },
        methods: {
            getCurrentBalanceData: function() {
                this.$Progress.start();
                axios.get('/api/getCurrentBalanceData')
                    .then(res => {
                        if(res.status == 200){
                            if(res.data.code == '200'){
                                this.balance = 'Master Account Balance: ' + this.formatAmount(res.data.data.balance);
                            }else{
                                this.balance = '';
                            }
                            this.$Progress.finish();
                        }else{
                            this.$Progress.fail();
                        }
                    })
                    .catch(err => {
                        this.$Progress.fail();
                    });
            },
            getCompanyVendorDashboardData(){
                axios.get('/api/companyVendorDashboard')
                    .then(res => {
                        if(res.status == 200){
                            this.data = res.data;
                            this.active_vendors_count = this.data.active_vendors_count;
                            this.vendors_proccessed_count = this.data.vendors_proccessed_count;
                            this.last_vendor_proccessed_amount = this.data.last_vendor_proccessed_amount;
                            this.recently_added_vendors = this.data.recently_added_vendors;
                            this.monthly_vendor_data = this.data.monthly_vendor_data;
                            this.monthly_bill_data = this.data.monthly_bill_data;
                        }
                    })
                    .then(res => {
                        if(this.vendors_proccessed_count > 0){
                            this.vendorPayments();
                        }
                    })
                    .catch(err => {
                        console.log(err);
                        this.showAlertBox('error','Error to load data');
                    });
            },
            vendorPayments: function (){
                var data = JSON.parse(this.monthly_vendor_data);
                var dates = data.dates_string;
                dates = dates.split(',');
                var cats = data.cats;
                var categories = {};
                var val = '';
                $.each(cats,function(index,value){
                    val = data.strings[value+"_str"]+'';
                    categories[index] = val.split(',').map(Number);
                });
                var series = [];
                var count = 0;
                $.each(categories,function(index, value)
                {
                    if(count == 0){
                        series.push(
                            {
                                name: index.replace('_',' '),
                                data: value,
                                color:colors[count],
                                borderColor: 'black',
                                borderWidth: 0,
                                style: {
                                    fontFamily: 'Raleway'
                                }
                            }
                        );
                    }else{
                        series.push(
                            {
                                name: index.replace('_',' '),
                                data: value,
                                color: colors[count],
                                borderColor: 'black',
                                borderWidth: 0,
                            }
                        );
                    }
                    count++;
                    if(count==9){
                        count = 1;
                    }
                });

                payroll_chart = Highcharts.chart({
                    chart: {
                        renderTo: 'vendor_payment',
                        type: 'column',
                        events: {
                            //load: requestData
                        },
                        style: {
                            fontFamily: 'Raleway',
                            borderWidth: 0,
                            align: 'right',
                        }
                    },
                    navigation: {
                        buttonOptions: {
                            verticalAlign: 'top',
                            y: -45
                        },
                    },
                    legend:{
                        itemStyle: {
                            fontSize:'12px',
                            fontWeight: '500',
                            color: '#686868'
                        },
                        itemWidth: 150,
                        verticalAlign: 'top',
                        align:'right',
                        y: 0,
                    },
                    credits: false,
                    title: {
                        text: null
                    },
                    xAxis: {
                        categories:dates ,
                        style: {
                            fontFamily: 'Raleway'
                        }
                    },
                    yAxis: {
                        allowDecimals: false,
                        title: {
                            text: 'Amount'
                        },
                    },
                    tooltip: {
                        pointFormatter: function(){
                            var price = this.y;
                            // price = format(price);
                            return '<span style="color:#282828;"> <b>'+price+'</span></b> '+this.series.name+'<br/>'
                        } ,
                        shared: true,
                        useHTML: true,
                        shadow: false,
                        headerFormat: '',
                    },
                    plotOptions: {
                        column: {
                            stacking: 'normal'
                        }
                    },
                    series: series
                });
            }

        }
    }
</script>
